import React from 'react';
import get from 'lodash/get';
import AvatarGroup from '@atlaskit/avatar-group';
import { SizeType } from '@atlaskit/avatar';
import { Maybe, EndCustomerContact } from '@css-xp/graphtypes/src/generated-types-new';
import { NoData } from '..';
import { NotificationTypes, successNotificationBuilder, useNotification } from '@css-xp/base';
import './customer-contact-avatar-group.scss';

// This is duplicate file from @css-xp/ppc-subscription-table
// We need to remove this file from @css-xp/ppc-subscription-table and use this file from @css-xp/ppc-common
export const CustomerContactsAvatarGroup = ({
  contacts,
  showContactType,
  avatarSize = 'medium',
  primaryLabel = 'Primary',
  secondaryLabel = 'Secondary',
}: {
  contacts: Maybe<Array<EndCustomerContact>> | undefined;
  showContactType?: boolean;
  avatarSize?: SizeType;
  primaryLabel?: string;
  secondaryLabel?: string;
}) => {
  const contactsStringified = JSON.stringify(contacts);
  const [avatarData, setAvatarData] = React.useState<EndCustomerContact[]>([]);
  const { sendSuccessNotification } = useNotification();
  React.useEffect(() => {
    if (contactsStringified) {
      const parsedViewers = JSON.parse(contactsStringified);
      if (parsedViewers) {
        const transformedViewerData: EndCustomerContact[] = (parsedViewers ?? []).map(
          (contact: EndCustomerContact) => ({
            key: contact.accountId,
            name: contact.name,
            src: contact.picture ?? '',
            email: contact.email,
          })
        );
        setAvatarData(transformedViewerData);
      }
    }
  }, [contactsStringified]);

  if (!contacts || contacts.length === 0) {
    return <NoData />;
  }

  const avatarGroupData = contacts?.map((contact: EndCustomerContact) => {
    return {
      key: contact.accountId,
      name: (
        <>
          <p>
            {contact.name}{' '}
            {showContactType && (get(contact, 'isPrimary', false) ? `(${primaryLabel})` : `(${secondaryLabel})`)}
          </p>
          <p>{contact.email}</p>
        </>
      ),
      email: contact.email,
      src: contact.picture ?? '',
      updatedAt: contact.updatedAt,
    };
  });

  const onAvatarClickHandler = (_event: unknown, _analyticsEvent: unknown, index: number) => {
    const email = avatarData[index].email ?? avatarData[index].name;
    navigator.clipboard.writeText(email);
    const notificationOptions = successNotificationBuilder()
      .withId('ecc-id-copied-successful-message')
      .withHeader('Successfully copied to clipboard')
      .withDismissAfter(5000)
      .isVersion(NotificationTypes.FLAG)
      .build();
    sendSuccessNotification(notificationOptions);
  };
  return (
    <div className="customer-contact-avatar-group">
      <AvatarGroup
        //@ts-ignore
        data={avatarGroupData}
        testId="customer-contact-avatar-group-ppc"
        {...{
          onAvatarClick: onAvatarClickHandler,
        }}
        size={avatarSize}
      />
    </div>
  );
};
